(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3UltimateScorecard', {
            templateUrl: 'app/home/ultimate-scorecard/ultimate-scorecard.component.html',
            controller: UltimateScorecardComponent,
            bindings: { facilities: '<' }
        });

    var checksum = angular.checksum;

    UltimateScorecardComponent.$inject = ['Score', 'user', 'alert', 'home_resources'];
    function UltimateScorecardComponent(Score, user, alert, resources) {
        // Variables
        var ctrl = this,
            rAbbreviation = /(?:\b(\w))|(.)/gi,
            monogramCount = 148; // <== comes from ultimate-scorecard.component.css

        // Properties
        ctrl.year = null;
        ctrl.yearList = null;
        ctrl.scorecard = null;

        // Methods
        ctrl.$onInit = init;
        ctrl.yearChange = yearChange;
        ctrl.showScorecard = showScorecard;

        ctrl.getAbbreviation = getAbbreviation;
        ctrl.getMonogramClass = getMonogramClass;

        ///////////////////////////////////////////////////////
        function init() {
            var year = ctrl.facilities.year;
            ctrl.year = year;
            ctrl.yearList = [year, year - 1, year - 2, null];
        }

        function yearChange() {
            Score.getUltimateScorecardFacilities({ individualId: user.id, year: ctrl.year }, success, error, true);

            function success(facilities) {
                ctrl.facilities = facilities;
            }
            function error(response) {
                alert.error(resources.ultimateFacilitiesRequestFailed);
            }
        }
        function showScorecard(facility) {
            var facilityId = facility.id,
                isDisabled = facility.scoreCount < 2;

            if (!isDisabled) 
                Score.getUltimateScorecard({ individualId: user.id, facilityId: facilityId, year: ctrl.year }, success, error, true);
            

            function success(data) {
                ctrl.scorecard = data;
            }
            function error() {
                alert.error(resources.ultimateScorecardRequestFailed);
            }
        }

        function getAbbreviation(name) {
            return name.replace(rAbbreviation, '$1').substr(0, 2).toUpperCase()
        }
        function getMonogramClass(name) {
            return 'monogram-' + (checksum(name) % monogramCount);
        }
    }
})();